import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=2fc422ed&scoped=true"
import script from "@/components/common/BookDemo/bookingForm.js?vue&type=script&lang=js&external"
export * from "@/components/common/BookDemo/bookingForm.js?vue&type=script&lang=js&external"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=2fc422ed&prod&lang=scss&scoped=true"
import style1 from "./BookingForm.vue?vue&type=style&index=1&id=2fc422ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc422ed",
  null
  
)

export default component.exports